import React, {useEffect } from "react";
import "../styles/CustomerAwareness.css";

const CustomerAwareness = () => {

    useEffect(() => {
        const reveals = document.querySelectorAll(".reveal");

        const revealOnScroll = () => {
            reveals.forEach((el) => {
                const windowHeight = window.innerHeight;
                const elementTop = el.getBoundingClientRect().top;
                if (elementTop < windowHeight - 100) {
                    el.classList.add("active");
                }
            });
        };

        window.addEventListener("scroll", revealOnScroll);
        revealOnScroll();
    }, []);

    return (
        <div className="awareness-page">
            {/* HERO */}
            <section className="awareness-hero">
                <h1>Customer Awareness</h1>
                <p>
                    Protecting you from fraud, scams, and digital banking threats.
                </p>
            </section>

            {/* INTERNET BANKING SAFETY */}
            <section className="split-section container reveal">
                <div className="split-image">
                    <img
                        src="https://images.unsplash.com/photo-1584438784894-089d6a62b8fa"
                        alt="Secure Banking"
                    />
                </div>
                <div className="split-content">
                    <h2>Secure Your Digital Banking Experience</h2>
                    <p>
                        The Sahyadri Sahakari Bank Ltd encourages customers to adopt safe
                        digital banking habits. Never share your OTP, PIN, CVV, or internet
                        banking password with anyone. Always access online banking through
                        secure and trusted devices. Avoid public WiFi networks while
                        performing financial transactions and regularly update your
                        passwords to maintain security.
                    </p>
                </div>
            </section>

            {/* FRAUD TYPES */}
            <section className="fraud-section container reveal">
                <h2 className="section-title">Common Banking Frauds</h2>

                <div className="fraud-grid">
                    {[
                        {
                            title: "Phishing Fraud",
                            img: "https://images.unsplash.com/photo-1563986768609-322da13575f3",
                            desc: "Fraudsters send fake emails or messages pretend to be the bank to steal your login credentials."
                        },
                        {
                            title: "ATM Skimming",
                            img: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc",
                            desc: "Devices installed in ATMs capture your card data and PIN without your knowledge."
                        },
                        {
                            title: "Fake Loan Calls",
                            img: "https://media.istockphoto.com/id/2074621494/photo/older-adults-are-targeted-by-phone-scams-and-fraud.webp?a=1&b=1&s=612x612&w=0&k=20&c=f1oCovTqincmDOkM-REyfiWpQNuYgkugp1chX-rkEgU=",
                            desc: "Scammers offer fake loan approvals and request advance fees or sensitive details."
                        },
                        {
                            title: "KYC Update Scam",
                            img: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b",
                            desc: "Fraudsters ask for urgent KYC updates and trick customers into revealing personal data."
                        },
                        {
                            title: "UPI / QR Code Scam",
                            img: "https://images.unsplash.com/photo-1605902711622-cfb43c4437b5",
                            desc: "Never scan unknown QR codes as it may lead to unauthorized debit from your account."
                        }
                    ].map((item, index) => (
                        <div
                            className="fraud-card"
                            key={index}
                            style={{ backgroundImage: `url(${item.img})` }}
                        >
                            <div className="fraud-overlay">
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* PHISHING SECTION (60% CONTENT / 40% IMAGE) */}
            <section className="info-split container reveal">
                <div className="info-content">
                    <h2>Phishing</h2>
                    <p>
                        Phishing is an attempt to acquire information such as usernames,
                        passwords and debit card details by disguised entities with malicious intent.
                    </p>
                    <p>
                        The bank will never ask for login credentials, OTP, CVV or PIN.
                    </p>
                    <ul>
                        <li>Never disclose OTP, CVV or password.</li>
                        <li>Do not click suspicious email links.</li>
                        <li>Type bank website directly in browser.</li>
                        <li>Change passwords frequently.</li>
                        <li>Install antivirus and firewall.</li>
                    </ul>
                </div>
                <div className="info-image">
                    <img src="https://images.unsplash.com/photo-1518770660439-4636190af475" alt="Phishing" />
                </div>
            </section>

            {/* SKIMMING SECTION (60% CONTENT / 40% IMAGE) */}
            <section className="info-split container reverse reveal">
                <div className="info-content">
                    <h2>Skimming & Vishing</h2>
                    <p>
                        Skimming is theft of debit card data during physical transactions.
                        Vishing uses voice calls to steal your personal information.
                    </p>
                    <ul>
                        <li>Always collect your card after transaction.</li>
                        <li>Cover keypad while entering PIN.</li>
                        <li>Never handover card to strangers.</li>
                        <li>Review statements regularly.</li>
                        <li>Report suspicious calls immediately.</li>
                    </ul>
                </div>
                <div className="info-image">
                    <img src="https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04" alt="Skimming" />
                </div>
            </section>



            {/* REPORT FRAUD */}
            <section className="report-section">
                <h2>Suspect Fraud? Act Immediately.</h2>
                <p>
                    If you notice any suspicious transaction or receive fraudulent
                    communication, contact our support team immediately to safeguard
                    your account.
                </p>

                <div className="report-buttons">
                    <a href="tel:22017477">📞 022 22033557</a>
                    <a href="mailto:support@thesahyadribank.com">
                        📧 support@thesahyadribank.com
                    </a>
                </div>
            </section>
        </div>
    );
};

export default CustomerAwareness;